import { render, staticRenderFns } from "./Deactivation-Reason.vue?vue&type=template&id=510e8b16"
import script from "./Deactivation-Reason.vue?vue&type=script&lang=js"
export * from "./Deactivation-Reason.vue?vue&type=script&lang=js"
import style0 from "./Deactivation-Reason.vue?vue&type=style&index=0&id=510e8b16&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports